const CLIENT_ID = process.env.MIX_CLIENT_ID

export default class Spektrix {
  get (endpoint, payload) {
    return this._fetch(endpoint, 'GET', payload)
  }

  post (endpoint, payload) {
    return this._fetch(endpoint, 'POST', payload)
  }

  delete (endpoint, payload) {
    return this._fetch(endpoint, 'DELETE', payload)
  }

  _fetch (endpoint, method, payload) {
    let body
    let params = ''

    if (payload) {
      if (payload.body) {
        body = JSON.stringify(payload.body)
      }
      if (payload.params && !payload.rawParams) {
        params = '?' + $.param(payload.params, true)
      }
      if (payload.rawParams) {
        params = payload.rawParams
      }
    }

    return fetch(`https://tickets.operanorth.co.uk/${CLIENT_ID}/api/v3/${endpoint}${params}`, {
      method: method,
      credentials: 'include',
      // mode: 'no-cors', // Set the mode to 'no-cors'
      headers: {
        'Content-Type': 'application/json'
      },
      body: body
    })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/classes/Spektrix.js